import React, { useMemo } from "react";
import { FormattedNumber } from "react-intl";
import { useFlexLayout, useTable } from "react-table";
import styled from "styled-components";
import { Button, Table } from "react-bootstrap";

const FlexDiv = styled.div`
  display: flex;
  justify-content: space-around;
`;

export const AlertConfigsTable = ({
  configs,
  onSelectConfig,
  onDeleteConfig,
}) => {
  const data = useMemo(() => configs, [configs]);
  const columns = useMemo(
    () => [
      {
        Header: "Symbol",
        accessor: "symbol",
      },
      {
        Header: "Minimum Fee",
        accessor: "minimum_fee",
        Cell: ({ value }) =>
          value != null ? (
            <FormattedNumber value={value / 100} style="percent" />
          ) : (
            "N/A"
          ),
      },
      {
        Header: "Maximum Fee",
        accessor: "maximum_fee",
        Cell: ({ value }) =>
          value != null ? (
            <FormattedNumber value={value / 100} style="percent" />
          ) : (
            "N/A"
          ),
      },
      {
        Header: "Minimum Available",
        accessor: "minimum_available",
        Cell: ({ value }) =>
          value != null ? <FormattedNumber value={value} /> : "N/A",
      },
      {
        Header: "Maximum Available",
        accessor: "maximum_available",
        Cell: ({ value }) =>
          value != null ? <FormattedNumber value={value} /> : "N/A",
      },
      {
        Header: "Active",
        accessor: "active",
        Cell: ({ value }) => (value ? <div>Active</div> : <div>Disabled</div>),
      },
      {
        Header: "Triggered",
        accessor: "triggered",
        Cell: ({ value }) => (value ? <div>Yes</div> : <div>No</div>),
      },
      {
        Header: "",
        accessor: "id",
        Cell: ({ value }) => (
          <FlexDiv>
            <Button onClick={() => onSelectConfig(value)} bsSize="small">
              Update
            </Button>
            <Button onClick={() => onDeleteConfig(value)} bsSize="small">
              Delete
            </Button>
          </FlexDiv>
        ),
      },
    ],
    []
  );
  const tableInstance = useTable({ columns, data, useFlexLayout });
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = tableInstance;

  return (
    <Table {...getTableProps()} hover>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps()}>{column.render("Header")}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()} style={{ textAlign: "center" }}>
              {row.cells.map((cell) => (
                <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
